import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {AuthService} from '../../../services/auth';
import {User} from '../../../classes/user';
import {Checklist} from '../../../classes/checklist';
import {ChecklistService} from '../../../services/checklist';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {GeneralModalComponent} from "../../../modals/general/general-modal/general-modal.component";
import {ChecklistCategory} from "../../../classes/checklistCategory";
import {ChecklistCategoryService} from "../../../services/checklistCategory";
import {ChecklistSubCategory} from "../../../classes/checklistSubCategory";
import {mergeMap, tap} from "rxjs/operators";
import {ChecklistSubCategoryService} from "../../../services/checklistSubCategory";

@Component({
  selector: 'app-checklist-detail',
  templateUrl: './checklist-category-detail.component.html',
  styleUrls: ['./checklist-category-detail.component.css']
})
export class ChecklistCategoryDetailComponent implements OnInit {
  // Pagination Parameters
  paginationConfig = {
    itemsPerPage: 10,
    currentPage: 1
  };
  paginationParams = {
    autoHide: true,
    maxSize: 7,
    responsive: true
  };
  paginationLabels = {
    previousLabel: 'Precedente',
    nextLabel: 'Successiva',
    screenReaderPaginationLabel: 'Paginazione',
    screenReaderPageLabel: 'pagina',
    screenReaderCurrentLabel: `Sei sulla pagina`
  };

  // Checklist Data
  user!: User;
  checklist!: Checklist;
  checklistCategory!: ChecklistCategory;
  checklistSubCategories: Array<ChecklistSubCategory> = [];

  constructor(private route: ActivatedRoute,
              private router: Router,
              private authService: AuthService,
              private modalService: NgbModal,
              private checklistService: ChecklistService,
              private checklistCategoryService: ChecklistCategoryService,
              private checklistSubCategoryService: ChecklistSubCategoryService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
        this.checklistCategoryService.getByID(params.get('id'))
            .pipe(
                tap((checklistCategory: any) => {
                    this.checklistCategory = checklistCategory;
                }),
                mergeMap(() => this.checklistService.getByID((this.checklistCategory.fk_id_checklist as number).toString())),
                tap((checklist: any) => {
                    this.checklist = checklist;
                }),
                mergeMap(() => this.checklistSubCategoryService.getByIDCategory((this.checklistCategory.id_checklist_category as number).toString()))
            )
            .subscribe({
                next: (checklistSubCategories: any) => {
                    this.checklistSubCategories = checklistSubCategories;
                    console.log(this.checklistSubCategories);
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    });
    this.user = this.authService.getUser();
  }

  pageChanged(event: any) {
    this.paginationConfig.currentPage = event;
  }

  openDeleteChecklistCategoryModal() {
      const modalRef = this.modalService.open(GeneralModalComponent);
      modalRef.componentInstance.title = 'Rimozione <strong>Macro Categoria</strong> Checklist';
      modalRef.componentInstance.text = 'Confermi la rimozione della macro categoria "' + this.checklistCategory.name + '"?';
      modalRef.result.then(() => {
          if (this.checklistCategory.id_checklist_category) {
              this.checklistCategoryService.delete(this.checklistCategory.id_checklist_category)
                  .subscribe({
                      next: () => {
                          this.router.navigate(['/checklist/' + this.checklist.id_checklist]);
                      },
                      error: (err: HttpErrorResponse) => {
                          console.log(err);
                      }
                  });
          }
      });
  }

    openDeleteChecklistSubCategoryModal(checklistSubCategory: ChecklistSubCategory) {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Rimozione <strong>Requisito</strong> Checklist';
        modalRef.componentInstance.text = 'Confermi la rimozione del requisito "' + checklistSubCategory.name + '"?';
        modalRef.result.then(() => {
            if (checklistSubCategory.id_checklist_subcategory) {
                this.checklistSubCategoryService.delete(checklistSubCategory.id_checklist_subcategory)
                    .subscribe({
                        next: () => {
                            this.checklistSubCategories = this.checklistSubCategories.filter((currChecklistSubCategory: ChecklistSubCategory) =>
                                currChecklistSubCategory.id_checklist_subcategory !== checklistSubCategory.id_checklist_subcategory);
                            this.paginationConfig.currentPage = 1;
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }
}
